// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToEndOfChain, addToStartOfChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    FindDefaultBillTo,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SetInitialValues";
import xLoadingOverlay from "@conklin/App/Handlers/XNG/LoadingOverlay";

type HandlerType = typeof FindDefaultBillTo;

export const setIsLoading: HandlerType = props => {
    props.dispatch(xLoadingOverlay({ key: "add", id: "set_initial_values" }));
};

export const setLoadingCompleted: HandlerType = props => {
    props.dispatch(xLoadingOverlay({ key: "clear", id: "set_initial_values" }));
};

addToStartOfChain(chain, setIsLoading);
addToEndOfChain(chain, setLoadingCompleted);
